import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import NotFound from '@/components/pages/errors/NotFound'

Vue.use(Router)

// Add a catch all for 404
routes.push({
  path: '*',
  component: NotFound
})

export default new Router({
  routes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      // Scroll to the target section as soon as it exists in the DOM, rather
      // than after a fixed delay — this avoids the page rendering at the top
      // first and then jumping (e.g. when navigating from the homepage cards).
      return new Promise((resolve) => {
        const position = { selector: to.hash, offset: { x: 0, y: 100 } }
        const tryScroll = (attempts) => {
          if (document.querySelector(to.hash) || attempts <= 0) {
            resolve(position)
          } else {
            requestAnimationFrame(() => tryScroll(attempts - 1))
          }
        }
        tryScroll(20)
      })
    }
    return {x: 0, y: 0}
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js